import client from './client';

export const importJson = (formData, config) =>
  client.post('/reporting/wildfires/json/import', formData, config).then((r) => r.data);

// The sniff endpoint is fast (no network calls beyond opening the workbook),
// so the default timeout is fine.
export const sniffExcel = (formData) =>
  client.post('/reporting/wildfires/excel/sniff', formData).then((r) => r.data);

// Preview fetches Open-Meteo for the full date range. Give it generous
// headroom — Lambda + API Gateway will still cut us off at ~29s, but axios
// shouldn't bail before then or the user gets a confusing client-side
// "Network Error" instead of the actual 503 the server emits.
export const previewExcel = (formData) =>
  client
    .post('/reporting/wildfires/excel/preview', formData, { timeout: 60_000 })
    .then((r) => r.data);

export const confirmExcelImport = (data) =>
  client.post('/reporting/wildfires/excel/confirm', data).then((r) => r.data);

export const exportExcel = (params) =>
  client.get('/reporting/wildfires/excel', { params, responseType: 'blob' });

export const exportJson = (params) =>
  client.get('/reporting/wildfires/json', { params, responseType: 'blob' });

// Full Seasonal Overview — a branded, board/cabinet-grade PDF for one fire season.
//
// Rendering takes ~26s and API Gateway caps an HTTP integration at 30s, which is
// its documented maximum and cannot be raised. So this is a two-step job: start
// it, then poll until it reports `completed` and carries a download URL. The
// render itself runs on the Lambda's own 900s budget, which leaves room for the
// report to grow rather than sitting a few seconds under a hard ceiling.
//
// `params` carries { fire_season, tenant_id }.
export const startSeasonalReport = (params) =>
  client.post('/reporting/wildfires/seasonal-report/start', null, { params });

export const getSeasonalReportJob = (jobId) =>
  client.get(`/reporting/wildfires/seasonal-report/jobs/${jobId}`);

// The original synchronous route. Still served, but it is the one bounded by the
// 30s ceiling — prefer the job above.
export const exportSeasonalPDF = (params) =>
  client.get('/reporting/wildfires/seasonal-report', { params, responseType: 'blob', timeout: 60_000 });
